import * as React from 'react';
import withFirestore from './withFirestore';

type DocumentState = {
  data: any;
  snapshot: firebase.firestore.DocumentSnapshot;
  isLoading: boolean;
  error: firebase.firestore.FirestoreError;
};

type RenderFunc = (args: DocumentState) => React.ReactNode;

type Props = {
  path: string;
  firestore: firebase.firestore.Firestore;
  children?: RenderFunc;
  render?: RenderFunc;
};

type State = DocumentState;

class FirestoreDocument extends React.Component<Props, State> {
  state: State = {
    isLoading: true,
    data: null,
    error: null,
    snapshot: null,
  };

  componentDidMount() {
    this.setupFirestoreListener();
  }

  componentWillReceiveProps(nextProps: Props) {
    const { path } = this.props;
    if (nextProps.path !== path) {
      this.handleUnsubscribe();

      this.setState({ isLoading: true }, () => this.setupFirestoreListener());
    }
  }

  componentWillUnmount() {
    this.handleUnsubscribe();
  }

  setupFirestoreListener = () => {
    const { path, firestore } = this.props;
    const documentRef = firestore.doc(path);

    this.unsubscribe = documentRef.onSnapshot(this.handleOnSnapshotSuccess, this.handleOnSnapshotError);
  };

  handleOnSnapshotError = (error: firebase.firestore.FirestoreError) => {
    this.setState({
      isLoading: false,
      error,
      data: null,
      snapshot: null,
    });
  };

  handleOnSnapshotSuccess = (snapshot: firebase.firestore.DocumentSnapshot) => {
    if (snapshot) {
      const newState: State = {
        data: null,
        isLoading: false,
        error: null,
        snapshot,
      };

      try {
        const documentData = snapshot.data();

        newState.data = {
          id: snapshot.id,
          ...documentData,
        };
      } catch (error) {
        newState.error = error;
      }

      this.setState(newState);
    }
  };

  handleUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  unsubscribe: () => void;

  render() {
    const { children, render } = this.props;

    if (render) return render(this.state);

    if (typeof children === 'function') return children(this.state);

    return null;
  }
}

export default withFirestore(FirestoreDocument);
